export default "//cdn.scentbird.com/assets/frontbird-site/images/faceMask_330921.png";